import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "49579e94-b6ea-4d4b-b9e4-e5b91ebc13a3",
    options: {
      imageDescription: "Thin gypsum board<br>+ min. wool<br>+ air gap",
      imageUrl: `${config.ASSETS_URL}/05/08/task/thin-gypsum.svg`,
    },
  },
  {
    id: "eef8a5cd-06ab-4842-a13e-589931d4eb71",
    options: {
      imageDescription: "Thin wooden panel<br>+ air gap",
      imageUrl: `${config.ASSETS_URL}/05/08/task/thin-wooden.svg`,
    },
  },

  {
    id: "b7381dbb-62d8-4460-8177-7ece80b3ee93",
    options: {
      imageDescription: "Perf. gypsum board<br>+ thin wool layer<br>+ air",
      imageUrl: `${config.ASSETS_URL}/05/08/task/perf-gypsum.svg`,
    },
  },
  {
    id: "ec1e512f-6081-4699-88f9-310cccd2a05e",
    options: {
      imageDescription: "Perf. wooden panel<br>+ min. wool layer<br>+ air",
      imageUrl: `${config.ASSETS_URL}/05/08/task/perf-wooden.svg`,
    },
  },

  {
    id: "e489c18f-3d3b-481b-bbbd-f41e07e246e4",
    options: {
      imageDescription: "Porous mineral wool slab",
      imageUrl: `${config.ASSETS_URL}/05/08/task/porous-foam.svg`,
    },
  },
  {
    id: "fddec58a-d40b-4091-a352-60cb8e22b1b0",
    options: {
      imageDescription: "Porous foam slab<br>+ air gap",
      imageUrl: `${config.ASSETS_URL}/05/08/task/porous-mineral.svg`,
    },
  },
];

const groups = [
  { id: "8980df81-5037-45dd-9247-77cc7450d0a9", content: "Low-frequency absorbers", options: {} },
  { id: "e4b2be43-1861-4f7a-b171-92e374804523", content: "Mid-frequency absorbers", options: {} },
  { id: "bc5a4711-4e27-4c74-acdc-6f22de9e7eca", content: "High-frequency absorbers", options: {} },
];

export const task: Task = {
  id: "290fbfeb-2f5b-4cea-a4bc-fe06e8b45267",
  solutionType: "group",
  type: "categorizeImages",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "8980df81-5037-45dd-9247-77cc7450d0a9",
      itemsId: ["49579e94-b6ea-4d4b-b9e4-e5b91ebc13a3", "eef8a5cd-06ab-4842-a13e-589931d4eb71"],
    },
    {
      groupId: "e4b2be43-1861-4f7a-b171-92e374804523",
      itemsId: ["b7381dbb-62d8-4460-8177-7ece80b3ee93", "ec1e512f-6081-4699-88f9-310cccd2a05e"],
    },
    {
      groupId: "bc5a4711-4e27-4c74-acdc-6f22de9e7eca",
      itemsId: ["e489c18f-3d3b-481b-bbbd-f41e07e246e4", "fddec58a-d40b-4091-a352-60cb8e22b1b0"],
    },
  ],
};
